import React from "react";
import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";

//TODO
//Use graphql for the select. Option id will be uppercase
const ContactTypeSelect = ({ value, onChange }) => {

	const options = [ {
		id: "General",
		name: intl.formatMessage({ id: "SHIP_CONTACT_TYPE_GENERAL" })
	}, {
		id: "Captain",
		name: intl.formatMessage({ id: "SHIP_CONTACT_TYPE_CAPTAIN" })
	}, {
		id: "Sailor",
		name: intl.formatMessage({ id: "SHIP_CONTACT_TYPE_SAILOR" })
	} ];

	return (
		<Select
			fetchOptions={options}
			value={options.find(option => option.id === value)}
			onChange={(option) => onChange(option.id)}
			clearable={false} />
	);
};

export default ContactTypeSelect;
